import { render, staticRenderFns } from "./RoltekLogo.vue?vue&type=template&id=b3ec5e80&scoped=true"
import script from "./RoltekLogo.vue?vue&type=script&lang=js"
export * from "./RoltekLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ec5e80",
  null
  
)

export default component.exports